import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fetchTestimonials } from "../lib/api";
import Stars from "./Stars";

const TestimonialCarousel = () => {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => { fetchTestimonials().then(setItems).catch(() => {}); }, []);

  if (!items.length) return null;
  const current = items[idx];

  const prev = () => setIdx((i) => (i - 1 + items.length) % items.length);
  const next = () => setIdx((i) => (i + 1) % items.length);

  return (
    <section className="py-16 vd-section-secondary" data-testid="testimonial-section">
      <div className="vd-container">
        <div className="text-center mb-10">
          <h2 className="mb-3">Customer Reviews</h2>
          <p className="vd-muted">What our customers say about us.</p>
        </div>
        <div className="max-w-3xl mx-auto vd-card p-8 md:p-10 relative" data-testid="testimonial-card">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <img src={current.photo} alt={current.author} className="w-20 h-20 rounded-full object-cover" style={{ border: "2px solid var(--primary-red)" }} />
            <div className="flex-1 text-center md:text-left">
              <Stars value={current.stars} size={18} />
              <p className="vd-body text-lg my-4" style={{ lineHeight: 1.6 }}>“{current.quote}”</p>
              <p className="vd-heading font-semibold">— {current.author}</p>
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 mt-6">
            <button onClick={prev} className="p-2 rounded-full border hover:bg-[var(--bg-secondary)]" style={{ borderColor: "var(--border-color)" }} aria-label="Previous review" data-testid="testimonial-prev"><ChevronLeft size={18} color="var(--text-heading)" /></button>
            <div className="flex gap-2">
              {items.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} aria-label={`Go to review ${i + 1}`} className="rounded-full" style={{ width: 10, height: 10, background: i === idx ? "var(--primary-red)" : "var(--border-color)" }} data-testid={`testimonial-dot-${i}`} />
              ))}
            </div>
            <button onClick={next} className="p-2 rounded-full border hover:bg-[var(--bg-secondary)]" style={{ borderColor: "var(--border-color)" }} aria-label="Next review" data-testid="testimonial-next"><ChevronRight size={18} color="var(--text-heading)" /></button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
